export default __webpack_public_path__ + "static/media/1.cc12f4cb.png";